type CardDataProps = {
  title: string;
  value?: string | number;
  iconElement?: React.ReactNode;
};

export const CardData = (props: CardDataProps) => {
  return (
    <div className="bg-white w-full h-28 px-5 py-4 rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl hover:border-[hsl(var(--primary))]/20 transition-all duration-300 flex justify-between gap-2">
      <div className="flex flex-col gap-1.5">
        <span className="text-sm font-medium text-gray-600">{props.title}</span>
        <span className="text-4xl font-bold tracking-tight">
          {props.value ?? 127}
        </span>
      </div>
      <div>{props.iconElement}</div>
    </div>
  );
};
